export default {
    'name': 'quotation',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M7.4903 21.7537L2.3999 13.6393V10.5145L7.3895 2.40015L11.6231 4.31535L7.9439 12.0769L11.6231 19.8889L7.4903 21.7537ZM17.9231 21.7537L12.8327 13.6393V10.5145L17.8223 2.40015L22.0559 4.31535L18.3767 12.0769L22.0559 19.8889L17.9231 21.7537Z\' fill=\'#0078CE\'/>'
}
